import styled from 'styled-components'

const StyledPaymentMethodPage = styled.div`
  .back-button-wrapper {
    margin: 15px 0 0 19px;
  }

  .back-button {
    font-family: ${({ theme }) => theme.fonts.lexend};
    color: #000000;
    letter-spacing: 1px;
    line-height: 40px;

    background: transparent;
    border: 0;
    display: flex;

    cursor: pointer;

    svg {
      height: 20px;
      flex-shrink: 0;
      position: relative;
      bottom: 1px;
      top: 10px;
      margin-right: 10px;
    }
  }

  .page-wrap {
    max-width: 355px;
    margin: 0 auto;
  }

  h1 {
    font-family: ${({ theme }) => theme.fonts.lexend};
    font-weight: normal;
    font-size: 32px;
    color: #232323;
  }

  h2 {
    font-family: ${({ theme }) => theme.fonts.lexend};
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.gray[400]};
  }

  .order-summary-container {
    margin-bottom: 25px;
  }

  .checkbox-container {
    margin-top: 40px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    .back-button-wrapper {
      margin: 72px 0 0 140px;
    }
  }

  .confirm-button {
    margin: 40px auto 0 auto;
  }
`

export default StyledPaymentMethodPage
